import React from 'react';
import { Projects } from '../../components';
function projects() {
  return (
    <>
      <Projects />
    </>
  );
}

export default projects;
